export enum ReceiptPrinterModeTypes {
  ALL = 'all',
  POS = 'pos',
  KITCHEN = 'kitchen',
  BILL = 'bill',
  CASH_REGISTER = 'cash-register',
  STAR_SCANNER = 'STAR_SCANNER',
  STAR_SCANNER_SUPPORTED = 'STAR_SCANNER_SUPPORTED'
}
